import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSearch } from 'src/hooks/use-search';
import { editDetectionZonePromise, type EditDetectionZonePromiseParam } from 'src/utils/api/edit-detection-zone';
import { QUERY_KEY_MAP } from 'src/constants';
import { clearShapesFn } from 'src/components/ZoneEditor/context';
import { useNotification } from 'src/hooks';

export const useEditDetectionZone = () => {
  const queryClient = useQueryClient();
  const { enqueueSuccessNotification } = useNotification();
  const [searchParams] = useSearch();
  const deviceId = searchParams?.device?.id || '';

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QUERY_KEY_MAP.useEditDetectionZone],
    mutationFn: editDetectionZonePromise,
  });

  const editDetectionZoneAsync = async (data: EditDetectionZonePromiseParam) => {
    try {
      await Promise.all([mutateAsync(data)]);

      clearShapesFn();
      enqueueSuccessNotification('saved.detection.zone');

      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetZoneLastUpdatedMeta, deviceId],
        }),

        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetDetectionZoneData, deviceId],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_MAP.useGetDeviceZoneVersionHistory, deviceId],
        }),
      ]);
    } catch (e) {
      console.error(e);
    }
  };

  return {
    editDetectionZoneAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
